export enum NetworkErrorCode {
  TERMS_AND_CONDITIONS = 'TERMSANDCONDITIONS',
  PRIVACY_POLICY = 'PRIVACYPOLICY',
  USER_EXPIRED = 'USEREXPIRED',
  VALIDATION_FAILURE = 'VALIDATION_FAILURE'
}
